import React from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Galerie des vidéos APPROUVÉES d'une activité (scope="activity") ou d'un guide
// (scope="guide"). N'affiche rien s'il n'y a aucune vidéo publiée.
export default function VideoGallery({ scope, id, title }) {
  const [videos, setVideos] = React.useState([]);
  const [active, setActive] = React.useState(null); // video_id en cours de lecture

  React.useEffect(() => {
    if (!id) return;
    const path = scope === 'guide'
      ? `/api/guides/${id}/videos`
      : `/api/activities/${id}/videos`;
    let alive = true;
    axios.get(`${API_URL}${path}`)
      .then((r) => { if (alive) setVideos(r.data.videos || []); })
      .catch(() => { if (alive) setVideos([]); });
    return () => { alive = false; };
  }, [scope, id]);

  if (!videos.length) return null;

  return (
    <div className="mt-6" data-testid="video-gallery">
      <h2 className="text-xl font-bold text-white mb-3">{title || 'Vidéos'}</h2>
      <div className="flex gap-3 overflow-x-auto pb-2">
        {videos.map((v) => (
          <div key={v.video_id} className="shrink-0 w-40 sm:w-44">
            <div
              className="relative rounded-xl overflow-hidden bg-black"
              style={{ aspectRatio: '9 / 16' }}
            >
              {active === v.video_id ? (
                <video
                  src={`${API_URL}${v.file_url}`}
                  poster={`${API_URL}${v.poster_url}`}
                  controls
                  autoPlay
                  playsInline
                  className="w-full h-full object-cover"
                />
              ) : (
                <button
                  type="button"
                  onClick={() => setActive(v.video_id)}
                  className="w-full h-full group"
                  aria-label="Lire la vidéo"
                >
                  <img
                    src={`${API_URL}${v.poster_url}`}
                    alt=""
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="w-12 h-12 rounded-full bg-black/50 backdrop-blur flex items-center justify-center transition group-hover:bg-[#f9004d]">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff"><path d="M8 5v14l11-7z" /></svg>
                    </span>
                  </span>
                </button>
              )}
            </div>
            <p className="text-zinc-400 text-xs mt-1 truncate">{v.author_label || v.traveler_name}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
